import { gql } from '@apollo/client';

import {
  V3AddMessageDocument,
  type V3AddMessageMutation,
  type V3AddMessageMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation V3AddMessage($input: AddMessageV3Input!) {
      addMessageV3(input: $input) {
        sent {
          id
          text
          createdAt
          sender
          optionRenderType
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
          messageAssets {
            id
            name
            url
            description
            createdAt
            updatedAt
            mimetype
          }
          metadata {
            isConversationOver
            maxSelections
            options {
              label
              value
              assets {
                id
                name
                url
                description
                createdAt
                updatedAt
              }
            }
            required
            type
            assistantQuestion
            questionId
          }
          transcript
          contentUrl
          mobileAppEmbedUrl
          mobileAppFileName
        }

        replyFeedback {
          id
          text
          createdAt
          sender
          optionRenderType
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
          messageAssets {
            id
            name
            url
            description
            createdAt
            updatedAt
            mimetype
          }
          transcript
          contentUrl
          mobileAppEmbedUrl
          mobileAppFileName
          metadata {
            isConversationOver
            maxSelections
            options {
              label
              value
              assets {
                id
                name
                url
                description
                createdAt
                updatedAt
              }
            }
            required
            type
            assistantQuestion
            questionId
          }
        }

        reply {
          id
          text
          createdAt
          sender
          optionRenderType
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
          messageAssets {
            id
            name
            url
            description
            createdAt
            updatedAt
            mimetype
          }
          transcript
          contentUrl
          mobileAppEmbedUrl
          mobileAppFileName
          metadata {
            isConversationOver
            maxSelections
            options {
              label
              value
              assets {
                id
                name
                url
                description
                createdAt
                updatedAt
              }
            }
            required
            type
            assistantQuestion
            questionId
          }
        }
        surveyProgress
        actions {
          preActivationActionType
          preActivationActionData
          postActivationActionType
          postActivationActionData
        }
      }
    }
  `;
}

export const V3_ADD_MESSAGE = V3AddMessageDocument;
export type { V3AddMessageMutation, V3AddMessageMutationVariables };
